<template>
    <div class="page">
        <div class="top" :style="{ backgroundImage: 'url('+detail.images+')' }">
            <van-icon name="arrow-left" class="go-back" @click="goBack"/>

            <h6 class="top-title">
                <span>{{detail.cropName}}·{{detail.breedName}}</span>
                <!--<van-button type="primary" class="btn">分享给好友</van-button>-->
            </h6>
            <p class="subtitle">
            <!--<span>批号：20200318</span>-->
            <!--<span>产地：山东省青岛市</span>-->
            </p>
            <ul class="card">
                <li class="card-cell" v-for="(item,index) in censusList" :key="index+'x'">
                    <span class="font">
                        <b class="card-titlt">{{item.title}}</b>
                        <label class="card-subtitle">{{item.subtitle}}</label>
                    </span>
                    <img class="icon" :src='"@/assets/image/farmShare/svg"+ (index+3) +".svg"'/>
                </li>
            </ul>
        </div>
        <div class="lists">
            <h6 class="list-title">产品追溯</h6>
            <ul class="tabs">
                <!--1用药   2生长    3施肥  5运输   6监测   7加工-->
                <span v-for="(value,key) in state">
                     <li v-if="key!=2"
                         @click="onChangeTab(key)"
                         :class="{'active': Number(activeTab) === Number(key) }">
                         {{value}}记录·{{record[key]}}</li>
                </span>
            </ul>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <ul class="records" v-if="dataList.length > 0">
                        <li class="rec-item" v-for="(item,index) in dataList" :key="index+'x'">
                                <div class="month">
                                    <p v-if="index == 0 ||
                                    (item.createTime &&
                                    Number(moment(item.createTime).format('M')) !==
                                    Number(moment(dataList[index-1].createTime).format('M')))">
                                        <span class="font"><b>{{moment(item.createTime).format('M')}}</b> 月</span>
                                        <img class="icon" src="@/assets/image/farmShare/svg5.svg"/>
                                    </p>
                                </div>
                                <div class="content">
                                    <h6 class="contnet-title">
                                <span class="title">
                                    <label class="tag-fant" :style="{background: bgFilter(item.notesType)}">
                                        {{state[item.notesType] || ''}}</label>
                                    <b>{{item.notes}}</b>
                                </span>
                                    </h6>
                                    <div class="imgs">
                                        <img v-for="(img,ind) in item.images"
                                             :key="img+ind"
                                             :src="img"
                                             class="img-item"
                                             @click="viewImg(item.images,ind)"/>
                                    </div>
                                    <div class="btms">
                                        <span class="times">
<!--                                            {{item.showDate ||''}}-->
                                          {{item.createTime && moment(item.createTime).format('MM月DD日')}}
                                        </span>
                                        <span class="follow">
                                            <img class="icon" src="@/assets/image/farmShare/follow.svg" alt="">
                                            {{item.stageName}}</span>
                                    </div>
                                </div>
                        </li>
                    </ul>
                </van-list>
            </van-pull-refresh>

        </div>


        <van-image-preview v-model="show" :images="images" @change="onImageChange">
            <template v-slot:index>第{{ index }}张</template>
        </van-image-preview>

    </div>
</template>

<script>
    import moment from "moment"
    export default {
        data(){
            return{
                moment,
                activeTab:1,
                detail:{},
                farmlandId:'',
                record:{},
                censusList:[
                    {
                        title:0,
                        subtitle:'用肥次数',
                    },
                    {
                        title:0,
                        subtitle:'用药次数',
                    },
                ],
                dataList: [],
                loading: false,
                finished: false,
                refreshing:false,
                sendData:{
                    current:0,
                    size:20,
                    farmlandId: null,
                    notesType: 1
                },
                total:0,
                state:{
                    1:'用药',
                    2:'生长',
                    3:'施肥',
                    5:'运输',
                    6:'监测',
                    7:'加工',
                },

                show: false,
                index: 0,
                images: [],

                initCheck:null,
            }
        },
        beforeRouteEnter(to,from,next){
            next((vm)=>{
                if(from.path === '/farmShare'){  //农庄分享
                    vm.initCheck = from.fullPath
                }else{
                    vm.initCheck = null
                }
            })
        },
        created() {
            this.detail = this.$route.query && JSON.parse(this.$route.query.data)
            this.sendData.farmlandId = this.detail.farmlandId
            this.getMapCount()
        },
        methods:{
            goBack(){
                if(!this.initCheck){
                    history.go(-1)
                }else{
                    let url = window.location.href.split("#")
                    console.log(`${url[0]}#${this.initCheck}&changeSwipe=true`)
                    window.location.href =`${url[0]}#${this.initCheck}&changeSwipe=true`
                }
            },
            /*
            * 统计数据
            * 1用药   2生长    3施肥  5运输   6监测   7加工
            * */
            getMapCount(){
                let {detail} = this
                this.$api.getMapCount({id:detail.farmlandId}).then(res=>{
                    this.record = res.data
                    this.censusList[0].title = res.data && res.data[1]
                    this.censusList[1].title = res.data && res.data[3]
                })
            },

            /*
            * 分页查询指定节点笔记列表
            * */
            getNotesPage(){
                let {sendData} = this
                // return
                this.$api.getNotesPage(sendData).then(res=>{
                    this.total = res.data.total
                    let rows = res.data.records  //请求返回当页的列表

                    if(rows === null || rows.length === 0){
                        this.finished = true
                        return
                    }

                    this.loading = false
                    this.dataList = [ ...this.dataList , ...rows ]

                    if(this.dataList.length >= this.total){
                        this.finished = true
                    }

                    setTimeout(() => {
                        this.refreshing = false
                    },1000)

                })
            },

            /*
            * 切换tab
            * */
            onChangeTab(notesType){
                this.sendData.notesType = this.activeTab = notesType
                this.sendData.current = 1
                this.dataList = []
                this.getNotesPage()
            },


            /*
            * 上拉加载
            * */
            onLoad() {
                // 异步更新数据
                setTimeout(() => {
                    this.sendData.current++
                    this.getNotesPage()
                }, 2000);
            },

            /*
            * 下拉刷新
            * */
            onRefresh() {
                this.sendData.current = 1
                this.dataList = []
                this.getNotesPage()
            },

            onImageChange(index) {
                this.index = index;
            },

            viewImg(imgs,index){
                this.show = true;
                this.index = index+1;
                this.images = imgs;
            },

            bgFilter(value){
                // 1:'用药',
                //     2:'生长',
                //     3:'施肥',
                //     5:'运输',
                //     6:'监测',
                //     7:'加工',
                switch(value) {
                    case 2:
                        return '#80BF02';
                    case 7:
                        return '#E75F7F';
                    case 6:
                        return '#4E75FF';
                    case 5:
                        return '#2241AB';
                    default:
                        return '#80BF02';
                }
            },

        },
    }
</script>

<style scoped lang="scss">
    @import './css/index';
</style>